import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Collapsible from 'react-collapsible';
import estilos from './FormularioFC08BeneficiarioComponent.module.css';
import { ArchivoComponent } from '../../ArchivosComponents/ArchivoComponent';
import { ArchivoOpcionalComponent } from './ArchivoOpcionalComponent';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import ModalEnviadoCorrectamente from '../../App/ModalEnviadoCorrectamente';
import {
    resetDataFC_08, actualizarFileFC_08,
    agregarFileFC_08, actualizarFC_08Estatus, actualizarFC_08Fecha,

} from '../../../redux/DucksBeneficiario/FC_08Ducks';
import moment from 'moment'


const DocumentacionFC_08Component = (props) => {
    const dispatch = useDispatch()
    const modoCorreccion = useSelector(store => store.FC_08Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_08Solicitud.dataDocumentacion)
    let granel = useSelector(store => store.FC_08Solicitud.granel)
    let exportacion = useSelector(store => store.FC_08Solicitud.exportacion)
    const fechaHoy = moment().format('YYYY-MM-DD');
    const filesExportacion = useSelector(store => store.FC_08Solicitud.files)
    const filesGranel = useSelector(store => store.FC_08Solicitud.filesCertificado)
    let filesExportacionMap = useSelector(store => store.FC_08Solicitud.filesExportacionMap)
    let filesGranelMap = useSelector(store => store.FC_08Solicitud.filesGranelMap)

    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [envioCorrecto, setEnvioCorrecto] = React.useState(false)

    const [folio, setFolio] = React.useState('')

    const obtenerNumeroDeFiles = async () => {

        const countArchivos = await contadorDocs()

        let totalFilesGenerales = 0

        let filtro = data.fc_08_anexocertificados.filter(filtro => filtro.tipocertificado == 'Granel')
        if (filtro.length > 0) totalFilesGenerales = filesgraneles.filter(file => file.estatus === true).length
        else totalFilesGenerales = filesgraneles.filter(file => file.estatus === true).length

        const contadorArchivo = totalFilesGenerales

        if (countArchivos > contadorArchivo) {
            setvalidacion(true)
            settexto("")
        } else {
            let fecha = new Date(fechaHoy).toISOString()
            let solicitud = { fechasolicitud: fecha, idfc08_renvacioncertificado: data.idfc08_renvacioncertificado }
            await dispatch(actualizarFC_08Fecha(solicitud))
            setFolio(data.folio)
            const idSolicitud = data.idfc08_renvacioncertificado
            const estatusNuevo = 2
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_08 = 3
            const tabla = tablaFC_08
            await dispatch(actualizarFC_08Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_08())
            setEnvioCorrecto(true)
        }
    }
    const contadorDocs = () => {
        let contador = 0
        for (const i in data.fc_08_anexocertificados) {
            if (data?.fc_08_anexocertificados?.[i]?.tipocertificado == 'Granel' &&
                data?.fc_08_anexocertificados?.[i]?.vencimientocertificado) contador += 2
            if (data?.fc_08_anexocertificados?.[i]?.tipocertificado != 'Granel' &&
                data?.fc_08_anexocertificados?.[i]?.vencimientocertificado) contador += 1
        }
        return contador
    }

    React.useEffect(() => {
        if (filesGranel) {
            let newFiles = []
            for (const file in filesGranel) {
                const { ...newFile } = filesGranel[file]
                newFiles.push(newFile)
            }
            setFilegraneles(newFiles)
        }
    }, [data])

    //FILES GRANELES 
    const [filesgraneles, setFilegraneles] = React.useState([])
    const handdleFileGraneles = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_08/agregarNuevoFC_08AnexosArchivosGraneles'
        }
        const result = await dispatch(agregarFileFC_08(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idfc_08archivoscertificados
            objectFile.estatus = true
            setFilegraneles(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }
    const handdleRemovePrevGraneles = async (objectFile) => {

        if (objectFile) {
            const newFiles = filesgraneles.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_08/actualizarFormatoFC08_AnexosArchivosGraneles'
                }
                const result = await dispatch(actualizarFileFC_08(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_08/agregarNuevoFC_08AnexosArchivosGraneles'
                    }
                    result = await dispatch(agregarFileFC_08(data))
                }
                if (result.payload.data?.data) {
                    setFilegraneles(newFiles)
                    return true
                } else {
                    const newFiles = filesgraneles.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFilegraneles(newFiles)
                    return false
                }
            }
        }
    }

    const FilesCertificados = () => {
        return (
            <div>
                <Collapsible trigger="Documentación de certificados" className='mb-3'>
                    {data.fc_08_anexocertificados?.map((anexo, index) => (
                        <Fragment>
                            {anexo.tipocertificado == 'Granel' &&
                                <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                    <label className='text-center'>Certificado: {anexo.numerocertificado}</label>
                                    {anexo.vencimientocertificado && <Fragment>
                                        <ArchivoComponent api={{ handdleFile: handdleFileGraneles, handdleRemovePrev: handdleRemovePrevGraneles, files: filesgraneles }} id={'DGAL' + index} tabla={"FC_08_anexos"}
                                            filesMap={filesGranelMap} idAnexoFK={anexo.idfc08_anexorenovacion}
                                            textLabel={`Análisis de laboratorio: ${anexo.numerocertificado}`} textoTooltip='Análisis de laboratorio' />
                                        <ArchivoComponent api={{ handdleFile: handdleFileGraneles, handdleRemovePrev: handdleRemovePrevGraneles, files: filesgraneles }} id={'DGCN' + index} tabla={"FC_08_anexos"}
                                            filesMap={filesGranelMap} idAnexoFK={anexo.idfc08_anexorenovacion}
                                            textLabel={`Certificado NOM a renovar: ${anexo.numerocertificado}`} textoTooltip='Certificado NOM a renovar' />
                                    </Fragment>
                                    }
                                    {anexo.otros &&
                                        <ArchivoOpcionalComponent api={{ handdleFile: handdleFileGraneles, handdleRemovePrev: handdleRemovePrevGraneles, files: filesgraneles }} id={'DGOD' + index} tabla={"FC_08_anexos"}
                                            filesMap={filesGranelMap} idAnexoFK={anexo.idfc08_anexorenovacion}
                                            textLabel={`Otro documento: ${anexo.numerocertificado}`} textoTooltip='Otro documento' />
                                    }
                                </div>
                            }
                            {(anexo.tipocertificado == 'Exportacion' || anexo.tipocertificado == 'Exportacion promocion') &&
                                <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                    <label className='text-center'>Certificado: {anexo.numerocertificado}</label>
                                    {(anexo.vencimientocertificado || anexo.cambioaduana || anexo.cambiocatidad ||
                                        anexo.cambiodestinatario || anexo.domicilioimportador || anexo.otros) &&
                                        <ArchivoComponent api={{ handdleFile: handdleFileGraneles, handdleRemovePrev: handdleRemovePrevGraneles, files: filesgraneles }} id={'DECN' + index} tabla={"FC_08_anexos"}
                                            filesMap={filesGranelMap} idAnexoFK={anexo.idfc08_anexorenovacion}
                                            textLabel={`Certificado NOM a renovar: `} textoTooltip='Certificado NOM a renovar' />}
                                    {(anexo.cambiocatidad || anexo.cambiodestinatario || anexo.domicilioimportador) &&
                                        <ArchivoOpcionalComponent api={{ handdleFile: handdleFileGraneles, handdleRemovePrev: handdleRemovePrevGraneles, files: filesgraneles }} id={'DEFP' + index} tabla={"FC_08_anexos"}
                                            filesMap={filesGranelMap} idAnexoFK={anexo.idfc08_anexorenovacion}
                                            textLabel={`Factura del producto: `} textoTooltip='Factura del producto' />
                                    }
                                    {anexo.otros &&
                                        <ArchivoOpcionalComponent api={{ handdleFile: handdleFileGraneles, handdleRemovePrev: handdleRemovePrevGraneles, files: filesgraneles }} id={'DEOD' + index} tabla={"FC_08_anexos"}
                                            filesMap={filesGranelMap} idAnexoFK={anexo.idfc08_anexorenovacion}
                                            textLabel={`Otro Documento: `} textoTooltip='Otro Documento' />
                                    }
                                </div>
                            }


                        </Fragment>
                    ))}
                </Collapsible>
            </div>
        )
    }


    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    return (
        <Fragment>
            <div className='row container ms-5'>
                <div className='ms-5'>
                    {FilesCertificados()}
                </div>
                <br />
                {
                    !modoCorreccion &&
                    <div className="text-center ms-5">
                        <button type="submit" onClick={() => obtenerNumeroDeFiles()}
                            className={`btn ${estilos.botonNaranjaRedondo}`}>Finalizar Envío</button>
                    </div>
                }

            </div>
            {envioCorrecto && <ModalEnviadoCorrectamente folioSolicitud={folio}></ModalEnviadoCorrectamente>}
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
        </Fragment>
    )
};

export default withRouter(DocumentacionFC_08Component)
